import { gsap, ScrollTrigger } from "../layout";

// rupiah format
function formatRupiah(number) {
    return new Intl.NumberFormat("id-ID").format(number); // Format angka ke Rupiah
}
function updateRupiahFormat(selector) {
    const elements = document.querySelectorAll(selector);

    elements.forEach((element) => {
        let number = parseInt(element.innerText.replace(/\D/g, ""), 10); // Ambil angka dari teks
        if (!isNaN(number)) {
            element.innerText = formatRupiah(number); // Ubah teks ke format Rupiah
        }
    });
}

// header section on donation form
function donationFormHeader() {
    const tabs = document.querySelectorAll(".wcdp-tab"); // Ambil semua tab
    const stepTitle = [acfData.header_title, "Detail", acfData.rangkuman]; // Deskripsi langkah
    const stepDescriptions = ["Next: Detail", "Next: Payment", ""]; // Deskripsi langkah

    tabs.forEach((tab, index) => {
        // Buat elemen header baru untuk setiap tab
        const donationHeader = document.createElement("div");
        donationHeader.classList.add("donation__header");
        donationHeader.innerHTML = `
            <h3 class="donation__header-title">${stepTitle[index]}</h3>
            <div class="donation__header-step">
                <span class="donation__header-step-number"><strong>Step <span class="count">${index + 1}</span></strong> / 3</span>
                ${stepDescriptions[index] ? `<span class="donation__header-step-description">${stepDescriptions[index]}</span>` :  ""}
            </div>
        `;

        // Sisipkan di awal setiap .wcdp-tab
        tab.prepend(donationHeader);
    });
}

// donation form amount on donation form step-1
function donationFormAmount() {
    // ====== add section header on amount section ======
    const donationAmount = document.createElement('div');
    donationAmount.classList.add('donation__section-header');
    donationAmount.innerHTML = 
    `
        <h4 class="donation__section-title">${acfData.nominal_label}</h4>
        <span class="donation__section-description">${acfData.nominal_description}</span>
    `;
    // Pilih elemen target
    const targetElement = document.querySelector('.wcdp_options');
    // Sisipkan elemen baru sebelum elemen target
    if (targetElement) {
        targetElement.before(donationAmount);
    }

    // ====== add button on amount section ======
    const otherAmountLi = document.querySelector("#wcdp_amount li:last-child");
    const donationOtherButton = document.createElement('li');
    donationOtherButton.classList.add('donation__other-amount-list');
    donationOtherButton.innerHTML = 
    `
        <div class="donation__other-amount-button wcdp-button-label">${acfData.nominal_button}</div>
    `;
    
    // amount other button header section
    const donationAmountOtherHeader = document.createElement('div');
    donationAmountOtherHeader.classList.add('donation__section-header--other-amount');
    donationAmountOtherHeader.innerHTML = 
    `
        <h4 class="donation__section-title">${acfData.nominal_button}</h4>
    `;
    
    if (otherAmountLi) {
        otherAmountLi.before(donationOtherButton);
        otherAmountLi.prepend(donationAmountOtherHeader);

        // Sembunyikan li terakhir saat halaman dimuat
        otherAmountLi.style.display = "none";
    }
    
    // Ambil elemen yang perlu dimanipulasi
    const otherAmountButton = document.querySelector(".donation__other-amount-button");
    const otherAmountInput = document.querySelector("#wcdp-donation-amount");
    const otherAmountRadio = document.querySelector("#wcdp_value_other");
    const radioButtons = document.querySelectorAll("#wcdp_amount input[type='radio']");

    if(otherAmountButton) {
        // Event listener ketika tombol 'Other' diklik
        otherAmountButton.addEventListener("click", function () {
            // Tampilkan li terakhir
            otherAmountLi.style.display = "block";
            otherAmountButton.classList.add("active");
    
            // Pilih radio button 'Other'
            otherAmountRadio.checked = true;
    
            // Fokus ke input angka
            otherAmountInput.focus();
        });
    }

    // Event listener untuk setiap radio button
    radioButtons.forEach((radio) => {
        radio.addEventListener("change", function () {
            // Jika radio yang dipilih bukan "Other", sembunyikan li terakhir
            if (!otherAmountRadio.checked) {
                otherAmountLi.style.display = "none";
                otherAmountButton.classList.remove("active");
                otherAmountInput.value = ""; // Kosongkan input untuk memastikan tidak ada nilai tersisa
            }
        });
    });
}

// currency section on donation form step-1
function donationFormCurrency() {
    // ====== add currency section on donation form ======
    const donationCurrency = document.createElement('div');
    donationCurrency.classList.add('donation__currency');
    donationCurrency.innerHTML = 
    `
        <div class="donation__section-header">
            <h4 class="donation__section-title">${acfData.kurs_label}</h4>
            <span class="donation__section-description">${acfData.kurs_description}</span>
        </div>
        <div class="donation__currency-wrapper"></div>
    `;
    // Pilih elemen target
    const targetElement = document.querySelector('.wcdp-row');
    // Sisipkan elemen baru sebelum elemen target
    if (targetElement) {
        targetElement.after(donationCurrency);
    }

    const donationCurrencyWrapper = document.querySelector('.donation__currency-wrapper');
    acfData.currency.forEach((currency) => {
        const currencyItem = document.createElement('span');
        currencyItem.classList.add('donation__currency-item');
        currencyItem.innerHTML = `
            <img src="${currency.icon}" class="donation__currency-icon" alt="${currency.code}">
            <span class="donation__currency-value">${currency.amount} <strong>${currency.code}</strong</span>
        `;
        donationCurrencyWrapper.appendChild(currencyItem);
    });
}

// selected amount section on donation form step-2
function donationGetAmount() {
    const radioButtons = document.querySelectorAll('input[name="donation-amount"]');
    const otherAmountInput = document.getElementById("wcdp-donation-amount");
    const displayElement = document.querySelector(".woocommerce__note-amount"); // Elemen untuk menampilkan nominal

    let selectedValue = "";

    radioButtons.forEach((radio) => {
        if (radio.checked) {
            selectedValue = radio.value;
        }
    });

    // Jika opsi "Nominal Lainnya" dipilih, gunakan input manual
    if (document.getElementById("wcdp_value_other")) {
        if (document.getElementById("wcdp_value_other").checked) {
            selectedValue = otherAmountInput.value || "0"; // Default ke 0 jika belum ada input
        }
    }

    // Konversi ke format Rupiah
    selectedValue = selectedValue ? `${formatRupiah(Number(selectedValue))}` : "0";

    // Update tampilan dengan nominal yang dipilih
    if (displayElement) {
        displayElement.textContent = selectedValue;
    }

    return selectedValue;
}

// woocommerce note on donation form step-2
function donationChangeAmount() {
    // add trigger to change amount link
    const triggerButton = document.querySelector(".woocommerce__note-change-amount"); // Tombol pemicu
    if (triggerButton) {
        triggerButton.addEventListener("click", function () {
            const buttonPrevStep2 = document.querySelector('#wcdp-step-2 .button.wcdp-button.wcdp-left')
            buttonPrevStep2.click();
        });
    }
}

// validate donation form on donation form step-2
const formWrapper = document.querySelector('.woocommerce-billing-fields__field-wrapper');
const submitButton = document.querySelector('#wcdp-step-2 .wcdp-button.wcdp-right');

if(submitButton) {
    // Disable button saat halaman pertama kali dimuat
    submitButton.disabled = true;
}

let requiredFields;
if(formWrapper) {
    requiredFields = formWrapper.querySelectorAll('input[aria-required="true"], select[aria-required="true"], textarea[aria-required="true"]');
}

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    return re.test(email.toLowerCase());
}
function validateField(field) {
    const value = field.value.trim();
    const type = field.getAttribute("type");
    const tag = field.tagName.toLowerCase();

    field.classList.remove("invalid");

    if (tag === "select") {
        return value !== "";
    }

    if (type === "email") {
        return validateEmail(value);
    }

    return value !== "";
}
function validateForm() {
    let isValid = true;

    requiredFields.forEach(field => {
        const valid = validateField(field);
        field.classList.toggle("invalid", !valid);
        if (!valid) {
            isValid = false;
        }
    });

    submitButton.disabled = !isValid;
}
if(formWrapper) {
    // Re-validate saat pengguna mengetik atau memilih
    requiredFields.forEach(field => {
        field.addEventListener("input", validateForm);
        field.addEventListener("change", validateForm);
    });
}

// preview section on donation form step-3
function donationPreviewTab() {   
    // ====== add button pembayaran on rangkuman step ======
    const donationAmount = document.createElement('div');
    donationAmount.classList.add('button', 'wcdp-button', 'wcdp-right', 'checkout-button');
    donationAmount.innerHTML = acfData.proses_pembayaran;
    // Pilih elemen target
    const targetElement = document.querySelector('#wcdp-step-3 .wcdp-button.wcdp-left');
    // Sisipkan elemen baru sebelum elemen target
    if (targetElement) {
        targetElement.after(donationAmount);
    }

    // ====== add trigger on button pembayaran ======
    const triggerButton = document.querySelector("#wcdp-step-3 .wcdp-button.wcdp-right"); // Tombol pemicu
    function triggerPlaceOrder() {
        const placeOrderButton = document.getElementById("place_order"); // Cek ulang tombol Midtrans
        if (placeOrderButton) {
            placeOrderButton.click(); // Memicu klik tombol Midtrans
        } else {
            // console.warn("Tombol Place Order belum tersedia.");
        }
    }
    if (triggerButton) {
        triggerButton.addEventListener("click", triggerPlaceOrder);
    }
    // Menggunakan MutationObserver untuk mendeteksi saat tombol "place_order" muncul
    const observer = new MutationObserver(() => {
        const placeOrderButton = document.getElementById("place_order");
        if (placeOrderButton) {
            observer.disconnect(); // Hentikan observer setelah tombol ditemukan
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

// footer section on donation form
function donationFormFooter() {
    // Pilih semua elemen dengan class "wcdp-tab"
    const sections = document.querySelectorAll('.wcdp-tab');    

    // Iterasi setiap section
    sections.forEach((section) => {
        // Cari semua elemen button di dalam section
        const buttons = section.querySelectorAll('.button.wcdp-button');

        if (buttons.length > 0) {
            // Buat elemen div baru
            const wrapperDiv = document.createElement('div');
            wrapperDiv.classList.add('donation__footer'); // Tambahkan class untuk styling

            // Pindahkan setiap button ke dalam div baru
            buttons.forEach((button) => {
                wrapperDiv.appendChild(button);                
            });

            // Tambahkan div ke dalam section
            section.appendChild(wrapperDiv);
        }
    });

    // remove default arrow on next button
    document.querySelectorAll(".wcdp-arrow.wcdp-right-arrow").forEach(element => {
        element.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.remove();
            }
        });
    });
}

// scroll to top on step change
function donationFormScroll() {
    const donationBanner = document.querySelector('.donation-banner');
    const nextButtonStep1 = document.querySelector('#wcdp-step-1 .wcdp-button');
    const backButtonStep2 = document.querySelector('#wcdp-step-2 .wcdp-button.wcdp-left');
    const nextButtonStep2 = document.querySelector('#wcdp-step-2 .wcdp-button.wcdp-right');
    const backButtonStep3 = document.querySelector('#wcdp-step-3 .wcdp-button.wcdp-left');

    if(donationBanner) {
        [nextButtonStep1, backButtonStep2, nextButtonStep2, backButtonStep3].forEach(item => {
            item.addEventListener('click', event => {
                let yValue;
                if (window.innerWidth < 576) {
                    yValue = -300;
                } else {
                    yValue = -50;
                }
    
                gsap.to(window, {
                    ease: "Power4.easeInOut",
                    duration: 0.4,
                    scrollTo: { y: donationBanner, offsetY: yValue }
                });
            })
        })    
    }
}

// certificate terms modal on step-1
function donationCertificateModal() {
    let modal = document.querySelector('.donation-modal');
    if (!modal) {
        modal = document.createElement('div');
        modal.classList.add('donation-modal');
        modal.innerHTML = `
            <div class="donation-modal__backdrop"></div>
            <div class="donation-modal__dialog">
                <button type="button" class="donation-modal__close" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                <h3 class="donation-modal__title">${acfData.modal_certificate_title}</h3>
                <div class="donation-modal__nominal-box">
                    <span class="donation-modal__nominal-text">
                        <span class="donation-modal__nominal-label">${acfData.modal_certificate_warning}</span>
                        <span class="donation-modal__nominal-value">Rp0</span>
                    </span>
                </div>
                <div class="donation-modal__description">
                    ${acfData.modal_certificate_description}
                </div>
                <div class="donation-modal__actions">
                    <button type="button" class="donation-modal__btn donation-modal__btn--change">
                        ${acfData.modal_certificate_btn_change}
                    </button>
                    <button type="button" class="donation-modal__btn donation-modal__btn--continue">
                        ${acfData.modal_certificate_btn_continue}
                    </button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
    }

    const backdrop = modal.querySelector('.donation-modal__backdrop');
    const closeBtn = modal.querySelector('.donation-modal__close');
    const btnChange = modal.querySelector('.donation-modal__btn--change');
    const btnContinue = modal.querySelector('.donation-modal__btn--continue');
    const nominalValueEl = modal.querySelector('.donation-modal__nominal-value');

    function openModal(formattedNominal) {
        if (nominalValueEl) {
            nominalValueEl.textContent = formattedNominal;
        }
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
    }

    [backdrop, closeBtn, btnChange].forEach((el) => {
        if (el) {
            el.addEventListener('click', closeModal);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            closeModal();
        }
    });

    function getRawDonationAmount() {
        let amount = 0;
        const otherRadio = document.getElementById("wcdp_value_other");
        const otherAmountInput = document.getElementById("wcdp-donation-amount");

        if (otherRadio && otherRadio.checked) {
            if (otherAmountInput && otherAmountInput.value !== "") {
                amount = parseInt(otherAmountInput.value.toString().replace(/\D/g, ""), 10) || 0;
            }
        } else {
            const radioButtons = document.querySelectorAll('#wcdp_amount input[type="radio"]:not(#wcdp_value_other)');
            radioButtons.forEach((radio) => {
                if (radio.checked) {
                    amount = parseInt(radio.value.toString().replace(/\D/g, ""), 10) || 0;
                }
            });
        }

        return amount;
    }

    const nextButtonStep1 = document.querySelector('#wcdp-step-1 .wcdp-button');
    let allowNext = false;

    if (nextButtonStep1) {
        nextButtonStep1.addEventListener('click', function (e) {
            if (!allowNext) {
                const rawAmount = getRawDonationAmount();

                // Validasi: hanya buka modal jika nominal sudah dipilih/diisi dan minimal 10000
                if (rawAmount < 10000) {
                    const otherRadio = document.getElementById("wcdp_value_other");
                    const otherAmountInput = document.getElementById("wcdp-donation-amount");
                    if (otherRadio && otherRadio.checked && otherAmountInput) {
                        otherAmountInput.reportValidity();
                        otherAmountInput.focus();
                    }
                    // Biarkan handler validasi bawaan WCDP yang memproses
                    return;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                openModal('Rp' + formatRupiah(rawAmount));
            } else {
                allowNext = false;
            }
        }, true);
    }

    if (btnContinue) {
        btnContinue.addEventListener('click', function () {
            closeModal();
            allowNext = true;
            if (nextButtonStep1) {
                nextButtonStep1.click();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    donationFormHeader();
    donationFormAmount();
    donationFormCurrency();
    donationChangeAmount();
    donationFormScroll();
    donationPreviewTab();
    donationFormFooter();
    donationCertificateModal();

    if(submitButton) {
        // Tunggu sejenak agar semua elemen benar-benar tersedia
        setTimeout(() => {
            submitButton.disabled = true; // Force disable awal
            validateForm(); // Langsung cek jika sudah autofill
        }, 0);
    }

    // get donation amount on donation form
    const radioButtons = document.querySelectorAll('input[name="donation-amount"]');
    const otherAmountInput = document.getElementById("wcdp-donation-amount");
    radioButtons.forEach((radio) => {
        radio.addEventListener("change", donationGetAmount);
    });
    if (otherAmountInput) {
        otherAmountInput.addEventListener("input", donationGetAmount);
    }
    // Jalankan sekali saat halaman dimuat untuk menampilkan nilai default
    donationGetAmount();

    // disable autofill checkout form
    document.querySelectorAll(".woocommerce-billing-fields__field-wrapper input, .woocommerce-billing-fields__field-wrapper select, .woocommerce-billing-fields__field-wrapper textarea").forEach(function(el) {
        el.value = "";
    });
})

window.addEventListener('resize', () => {
    
})

// change review-order table after ajax checkout updated
// jQuery(function($) {  
//     let buttonNextStep1 = document.querySelector('#wcdp-step-1 .wcdp-button');
//     let productName = document.querySelector('.woocommerce-checkout-review-order-table .product-name');
//     let orderTotal = document.querySelector('.woocommerce-checkout-review-order-table .order-total th');

//     buttonNextStep1.addEventListener('click', (el) => {        
//         setTimeout(function(){
//         $(document.body).on('updated_checkout', function () {
//                 console.log(productName);
//                 console.log(orderTotal);
//             });
//         }, 1000);
//     })
// });